<template>
  <div class="goods-edit-page container">
    <div class="clearfix" style="text-align: center">
      <div class="edit-dom">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
        <el-form-item label="选择应用" prop="app_id">
            <el-select
              v-model="ruleForm.app_id"
              placeholder="选择应用"
              style="width: 100%"
            >
              <el-option
                v-for="item in app_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品类型" prop="type">
            <el-select v-model="ruleForm.type" placeholder="选择类型" style="width: 100%" >
              <el-option
                v-for="item in type_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建类型" prop="create_type">
            <el-select v-model="ruleForm.create_type" placeholder="选择类型" style="width: 100%" >
              <el-option
                v-for="item in create_type_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机壳吗" prop="is_phone_case">
            <el-select v-model="ruleForm.is_phone_case" placeholder="请选择" style="width: 100%" >
              <el-option
                v-for="item in is_phone_case_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="菲林壳吗" prop="is_film_case">
            <el-select v-model="ruleForm.is_film_case" placeholder="请选择" style="width: 100%" >
              <el-option
                v-for="item in is_film_case_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="轮播图" prop="images">
            <el-upload
              :action="
                '/seller-api/v1/pub/helpers/upload-file-seller?dir_tag=goods&token=' +
                token
              "
              list-type="picture-card"
              :on-success="handleSuccessThumb"
              :on-preview="handlePictureCardPreviewThumb"
              :file-list="ruleForm.images"
              :on-remove="handleRemoveThumb"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <el-form-item label="商品名称" prop="title">
            <el-input
              v-model="ruleForm.title"
              placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="英文名称" prop="title_en">
            <el-input
              v-model="ruleForm.title_en"
              placeholder="请输入英文名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="短标题" prop="title_short">
            <el-input
              v-model="ruleForm.title_short"
              placeholder="example:Glass Case"
            ></el-input>
          </el-form-item>
          <el-form-item label="SEO名称" prop="title_seo">
            <el-input
              v-model="ruleForm.title_seo"
              placeholder="请输入SEO名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品分类" prop="category_id">
            <el-select
              v-model="ruleForm.category_id"
              placeholder="请选择分类"
              style="width: 100%"
            >
              <el-option
                v-for="item in category_options"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格" prop="attributes">
            <div>
              <i
                class="m-r-10 m-t-10 el-icon-plus pointer"
                @click="addAttribute"
              ></i>
            </div>
            <div>
              <section
                class="clearfix"
                v-for="(attr, index_attr) in ruleForm.attributes"
                :key="index_attr"
              >
                <i
                  class="m-r-10 m-t-10 fl el-icon-close pointer"
                  @click="delAttribute(attr.name)"
                ></i>
                <section class="fl">
                  <el-input
                    v-model="attr.name"
                    placeholder="请输入规格名称"
                    class="w140"
                  ></el-input>
                  <el-select v-model="attr.enable_value_image" placeholder="启用图片" style="width: 100px" >
                    <el-option v-for="item in enable_value_image_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </section>
                <section class="fl m-l-10">
                  <div
                    class="m-b-5 clearfix"
                    v-for="(attr_item, index_item) in attr.items"
                    :key="index_item"
                  >
                    <div class="fl">
                      <el-input
                        v-model="attr_item.value"
                        placeholder="请输入属性值"
                        class="w300"
                        @input="flushSku"
                      ></el-input>
                      <div class="relative">
                        <el-upload
                          class="avatar-uploader"
                          :action="
                            '/seller-api/v1/pub/helpers/upload-file-and-save-design?dir_tag=sku-line&token=' +
                            token
                          "
                          :show-file-list="false"
                          :on-remove="handleRemove_specImage"
                          list-type="picture"
                          :on-success="
                            (response, file, fileList) => {
                              return uploadSpecImageSuccess(
                                response,
                                file,
                                fileList,
                                index_attr,
                                index_item
                              );
                            }
                          "
                        >
                          <img
                            v-if="attr_item.hasOwnProperty('image') && attr_item.image"
                            :src="attr_item.image.file_oss"
                            style="width: 64px; height: auto"
                          />
                          <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon"
                            style="width: 32px; height: 32px; line-height: 32px"
                          ></i>
                        </el-upload>
                        <i class="el-icon-close pointer" @click="handleRemove_specImage(index_attr, index_item)" v-if="attr_item.hasOwnProperty('image') && attr_item.image" style="position: absolute;top: 0;left:80px;"></i>
                      </div>
                    </div>
                    <div class="fl m-l-10">
                      <i
                        class="el-icon-plus pointer gray-color"
                        @click="addAttributeItem(attr.name)"
                      ></i>
                      <i
                        class="el-icon-minus pointer gray-color m-l-10"
                        @click="delAttributeItem(attr.name, attr_item.value)"
                      ></i>
                    </div>
                  </div>
                </section>
              </section>
            </div>
          </el-form-item>
          <el-form-item
            label="SKU"
            prop="count_stock"
            v-if="ruleForm.sku_list.length > 0"
            style="margin-right: 5px"
          >

            <div style="margin-bottom: 32px;">
              <el-table :data="default_value_form" style="width: 100%">
                <el-table-column prop="price" label="价格" width="90">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.price"
                      placeholder="0.00"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="price_original" label="原价" width="90">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.price_original"
                      placeholder="0.00"
                      @input="cacheSku(scope.row)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="vat_target_price" label="申报价格(target)" width="166">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.vat_target_price"
                      placeholder="0.00"
                      @input="cacheSku(scope.row)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="vat_local_price" label="申报价格(local)" width="166">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.vat_local_price"
                      placeholder="0.00"
                      @input="cacheSku(scope.row)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="count_stock" label="库存" width="90">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.count_stock"
                      placeholder="0"
                      @input="cacheSku(scope.row)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="count_sales" label="销量" width="90">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.count_sales"
                      placeholder="0"
                      @input="cacheSku(scope.row)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="sku_weight" label="重量" width="90">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.sku_weight"
                      placeholder="0"
                      @input="cacheSku(scope.row)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="sku_weight" label="操作" width="90">
                  <template slot-scope="scope">
                    <el-button @click="apply_default_value">应用</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>



            <el-table :data="ruleForm.sku_list" style="width: 100%">
              <el-table-column prop="date" label="主图" width="88">
                <template slot-scope="scope">
                  <el-upload
                    class="avatar-uploader"
                    :action="
                      '/seller-api/v1/pub/helpers/upload-file-seller?dir_tag=goods&token=' +
                      token
                    "
                    :show-file-list="false"
                    :on-success="
                      (value) => handleSkuImgSuccess(scope.row, value)
                    "
                  >
                    <img
                      v-if="scope.row.image"
                      :src="scope.row.image"
                      class="avatar-mini"
                    />
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon-mini"
                    ></i>
                  </el-upload>
                </template>
              </el-table-column>
              <el-table-column prop="sku_code" label="规格" width="133">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.sku_code"
                    placeholder="规格"
                    :disabled="true"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="价格" width="90">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.price"
                    placeholder="0.00"
                    @input="cacheSku(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="price_original" label="原价" width="90">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.price_original"
                    placeholder="0.00"
                    @input="cacheSku(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="vat_target_price" label="申报价格(target)" width="166">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.vat_target_price"
                    placeholder="0.00"
                    @input="cacheSku(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="vat_local_price" label="申报价格(local)" width="166">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.vat_local_price"
                    placeholder="0.00"
                    @input="cacheSku(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="count_stock" label="库存" width="90">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.count_stock"
                    placeholder="0"
                    @input="cacheSku(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="count_sales" label="销量" width="90">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.count_sales"
                    placeholder="0"
                    @input="cacheSku(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="sku_weight" label="重量" width="90">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.sku_weight"
                    placeholder="0"
                    @input="cacheSku(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="视频链接" prop="video_url">
            <el-input
              v-model="ruleForm.video_url"
              placeholder="url"
              class="w400"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品描述" prop="describes">
            <div style="width: 660px">
              <editor-bar
                v-model="ruleForm.describes"
                :isClear="isClearEditor"
                @change="changeContent"
              ></editor-bar>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              v-loading="submitLoading"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import EditorBar from "../public/_wangEditor";
export default {
  components: {
    EditorBar,
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      dialogVisible: false,
      isClearEditor: false,
      dialogImageUrl: "",
      token: localStorage.getItem("token"),
      default_value_form:[{
        price: "",
        price_original: "",
        vat_target_price: "",
        vat_local_price: "",
        count_stock: 0,
        sku_weight: 0.01,
        count_sales: 0,
      }],
      ruleForm: {
        id: 0,
        app_id: "",
        category_id: "",
        title: "",
        title_en: "",
        title_short: "",
        title_seo: "",
        design_info: "",
        page_path: "",
        describes: "",
        attributes: [],
        images: [],
        video_url:"",
        video_cover:"",
        sku_list: [],
        type: '',
        create_type:'',
        is_phone_case:0,
        is_film_case:0,
      },
      rules: {
        app_id: [{ required: true, message: "请选择应用", trigger: "change" }],
        images: [{ required: true, message: "请上传主图", trigger: "change" }],
        title: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        create_type: [{ required: true, message: "请选择创建类型", trigger: "change" }],
        title_en: [
          { required: true, message: "请输入英文名称", trigger: "blur" },
        ],
        describes: [
          { required: true, message: "请输入商品描述", trigger: "blur" },
        ],
        category_id: [
          { required: true, message: "选择分类", trigger: "change" },
        ],
        is_phone_case: [
          { required: true, message: "是否手机壳必选", trigger: "change" },
        ],
        is_film_case: [
          { required: true, message: "是否菲林壳必选", trigger: "change" },
        ],
      },
      type_options: [
        {value:1, label:'普通商品'},
        {value:2, label:'DIY商品'}
      ],
      create_type_options: [
        {value:1, label:"商品"},
        {value:2, label:"素材"},
      ],
      is_film_case_options: [
        {value:0, label:'否'},
        {value:1, label:'是'}
      ],
      is_phone_case_options: [
        {value:0, label:'否'},
        {value:1, label:'是'}
      ],
      enable_value_image_options: [
        {value:0, label:'否'},
        {value:1, label:'是'}
      ],
      category_options: [],
      attribute_options: [],
      app_options: [],
    };
  },
  methods: {
    //规格操作
    addAttribute() {
      var attributes = this.ruleForm.attributes;
      attributes.push({
        name: "",
        enable_value_image:0,
        items: [
          {
            value: "",
            image: null,
          },
        ],
      });
      this.ruleForm.attributes = attributes;
      this.flushSku();
    },
    delAttribute(attr_name) {
      var attr = this.ruleForm.attributes;
      var tmp = [];
      for (var i = 0; i < attr.length; i++) {
        if (attr_name != attr[i].name) {
          tmp.push(attr[i]);
        }
      }
      this.ruleForm.attributes = tmp;
      this.flushSku();
    },
    addAttributeItem(attr_name) {
      var attr = this.ruleForm.attributes;
      for (var i = 0; i < attr.length; i++) {
        if (attr_name == attr[i].name) {
          attr[i].items.push({
            value: "",
            image: null,
          });
        }
      }
      this.ruleForm.attributes = attr;
      this.flushSku();
    },
    delAttributeItem(attr_name, item_value) {
      var attr = this.ruleForm.attributes;
      for (var i = 0; i < attr.length; i++) {
        if (attr_name == attr[i].name) {
          var tmp_items = [];
          for (var j = 0; j < attr[i].items.length; j++) {
            if (item_value != attr[i].items[j].value) {
              tmp_items.push(attr[i].items[j]);
            }
          }
          attr[i].items = tmp_items;
        }
      }
      this.ruleForm.attributes = attr;
      this.flushSku();
    },
    //二维数组排列组合
    combination (dimensionalArr) {
      const FLength = dimensionalArr.length;
      if (FLength >= 2) {
        const SLength1 = dimensionalArr[0].length;
        const SLength2 = dimensionalArr[1].length;
        const DLength = SLength1 * SLength2;
        const temporary = new Array(DLength);
        let index = 0;
        for (let i = 0; i < SLength1; i++) {
          for (let j = 0; j < SLength2; j++) {
            if (Array.isArray(dimensionalArr[0][i])) {
              temporary[index] = [].concat([...dimensionalArr[0][i], dimensionalArr[1][j]]);
            } else {
              temporary[index] = [].concat([dimensionalArr[0][i], dimensionalArr[1][j]]);
            }
            index++;
          }
        }
        const newArray = new Array(FLength - 1);
        newArray[0] = temporary;
        for (let j = 2; j < FLength; j++) {
          newArray[j - 1] = dimensionalArr[j];
        }
        return this.combination(newArray);
      } else {
        if (dimensionalArr[0] && dimensionalArr[0][0] && Array.isArray(dimensionalArr[0][0])) {
          return dimensionalArr[0];
        }
        return dimensionalArr;
      }
    },
    cacheSku(item) {
      var cacheKey = "attr_" + item.sku_code + "_" + this.ruleForm.id;
      localStorage.setItem(cacheKey, JSON.stringify(item));
    },
    flushSku() {
      var tmp = new Object();
      var attr = this.ruleForm.attributes;
      for (var i = 0; i < attr.length; i++) {
        for (var j = 0; j < attr[i].items.length; j++) {
          var k = attr[i].name + '-' + i + ':' + attr[i].items[j].value;
          var lines = new Array();
          if ( tmp.hasOwnProperty(i) ) {
            lines = tmp[i];
          }
          lines.push(k);
          tmp[i] = lines;
        }
      }
      var arr = [];
      for (var i in tmp) {    arr.push(tmp[i]); }
      var sku_codes = this.doExchange(arr);

      var sku_list = [];
      for (var i = 0; i < sku_codes.length; i++) {
        var cacheData = this.findSkuByUniqueId(sku_codes[i])
        if (cacheData == null) {
          var attributes = [];
          var exp_arr = sku_codes[i].split("#") //color-0:c1#size-1:s1
          var sku_code_name_arr = [];
          var sku_code_value_arr = [];
          for (var j=0; j<exp_arr.length; j++) {
            var _x_arr  = exp_arr[j].split(":");//color-0:c1
            var _x2_arr = _x_arr[0].split("-");//color-0
            var _name = _x2_arr[0];
            var _name_index = _x2_arr[1];
            var _value = _x_arr[1];
            attributes.push({
              name:_name,
              value:_value,
              index:_name_index,
            })
            sku_code_name_arr.push(_name)
            sku_code_value_arr.push(_value)
          }
          var sku_code_name_str = sku_code_name_arr.join(",");
          var sku_code_value_str = sku_code_value_arr.join(",");
          cacheData = {
            id:0,
            unique_id: sku_codes[i],
            sku_name: sku_code_name_str,
            sku_code: sku_code_value_str,
            price: "",
            price_original: "",
            vat_target_price: "",
            vat_local_price: "",
            count_stock: 0,
            sku_weight: 0.01,
            count_sales: 0,
            image: "",
            attributes: attributes,
            is_default: 0,
          };
        }
        sku_list.push(cacheData);
      }

      this.ruleForm.sku_list = sku_list;
      console.log(this.ruleForm, 'this.ruleForm---->>>')
    },
    findSkuByUniqueId(unique_id){
      for (var i=0; i<this.ruleForm.sku_list.length; i++) {
        if ( this.ruleForm.sku_list[i].unique_id == unique_id ) {
          return this.ruleForm.sku_list[i]
        }
      }
      return null;
    },
    doExchange(doubleArrays){
        var len=doubleArrays.length;
        if (len >= 2) {
            var len1 = doubleArrays[0].length;
            var len2 = doubleArrays[1].length;
            var newlen = len1 * len2;
            var temp = new Array(newlen);
            var rowIndex=0;
            for(var index = 0; index < len1; index++){
                for(var cursor = 0; cursor < len2; cursor++){
                    temp[rowIndex] = doubleArrays[0][index] + '#' + doubleArrays[1][cursor];

                    rowIndex++;
                }
            }
            var newArray = new Array(len-1);
            for (var index = 2; index < len; index++) {
                newArray[index - 1] = doubleArrays[index];
            }
            newArray[0] = temp;
            var result = this.doExchange(newArray);
            return result;
        } else {
            var result = doubleArrays[0];
            return result;
        }
    },
    //富文本
    changeContent(val) {
      this.ruleForm.describes = val;
    },
    //主图
    handlePhotoMainSuccess(res, file) {
      if (res.code == 1) {
        this.ruleForm.photo_main = res.data.url;
      }
    },
    handleIconSuccess(res, file) {
      if (res.code == 1) {
        this.ruleForm.icon = res.data.url;
      }
    },
    beforeAvatarUpload(file) {
      return true;
    },
    handleSkuImgSuccess(sku, res) {
      var list = this.ruleForm.sku_list;
      for (var i = 0; i < list.length; i++) {
        if (sku.id == list[i].id) {
          list[i].image = res.data.url;
          this.cacheSku(list[i]);
        }
      }
      this.ruleForm.sku_list = list;
    },
    uploadSpecImageSuccess(response, file, fileList, index_attr, index_item) {
      var f = file.response.data;
      this.ruleForm.attributes[index_attr].items[index_item].image = {
        file_id:f.id,
        file_oss:f.file_oss,
        file_local:f.file_local,
      };
    },
    handleRemove_specImage(index_attr, index_item){
      this.ruleForm.attributes[index_attr].items[index_item].image = null;
    },
    handleSuccessThumb(upRes, e) {
      if (upRes.code == 1) {
        var list = this.ruleForm.images;
        list.push({
          id: this.uniqueId(),
          name: e.name,
          url: upRes.data.file_oss,
        });
        this.ruleForm.images = list;
      }
    },
    handleRemoveThumb(file, fileList) {
      this.ruleForm.images = fileList;
    },
    handlePictureCardPreviewThumb(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getCategorys() {
      this.$http
        .post("/v1/pri/goods-category/lists", { size: 100, page: 1 })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.category_options = res.data.list;
          }
        });
    },
    getAttribute() {
      this.$http
        .post("/v1/pri/goods-attribute/lists", { size: 100, page: 1 })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.attribute_options = res.data.list;
          }
        });
    },
    getApp() {
      this.$http
        .post("/v1/pri/cfg-applets/options", { size: 100, page: 1 })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.app_options = res.data.list;
          }
        });
    },
    getDetail() {
      if (!this.ruleForm.id) {
        return;
      }
      this.$http
        .post("/v1/pri/goods/detail", { id: this.ruleForm.id })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.ruleForm = res.data;
            if (this.ruleForm.channel_id == 0) this.ruleForm.channel_id = "";
            if (this.ruleForm.group_id == 0) this.ruleForm.group_id = "";
            if (this.ruleForm.standard_id == 0) this.ruleForm.standard_id = "";
            if (this.ruleForm.count_sales == 0) this.ruleForm.count_sales = "";
            if (this.ruleForm.count_stock == 0) this.ruleForm.count_stock = "";
            if (this.ruleForm.sku_weight == 0) this.ruleForm.sku_weight = 0.01;
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    apply_default_value(){
      var sku_list = this.ruleForm.sku_list;
      for (var i =0; i<sku_list.length; i++) {
        sku_list[i].price = this.default_value_form[0].price;
        sku_list[i].price_original = this.default_value_form[0].price_original;
        sku_list[i].vat_target_price = this.default_value_form[0].vat_target_price;
        sku_list[i].vat_local_price = this.default_value_form[0].vat_local_price;
        sku_list[i].count_stock = this.default_value_form[0].count_stock;
        sku_list[i].sku_weight = this.default_value_form[0].sku_weight;
        sku_list[i].count_sales = this.default_value_form[0].count_sales;
      }
      this.ruleForm.sku_list = sku_list;
    },
    //提交
    submitForm(formName) {
      this.submitLoading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post("/v1/pri/goods/save", this.ruleForm)
            .then((response) => {
              this.submitLoading = false;
              var res = response.data;
              if (res.code == 1) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });

                setTimeout(() => {
                  this.redirect("/goods/detail?id=" + res.data.id);
                }, 1000);
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            });
        }
      });
    },
  },
  mounted() {
    this.$store.commit('set_current_menu', {name:'goods'});
    this.ruleForm.id = this.getUrlParam("id");
    this.getCategorys();
    this.getAttribute();
    this.getApp();
    this.getDetail();
  },
};
</script>
<style>
.goods-edit-dialog {
  width: 640px;
  padding-right: 32px;
  box-sizing: border-box;
}
.goods-edit-page .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.goods-edit-page .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.goods-edit-page .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.goods-edit-page .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.goods-edit-page .avatar-icon {
  width: 64px;
  height: 64px;
}
.goods-edit-page .avatar-uploader-icon-mini {
  width: 72px;
  height: 72px;
  line-height: 72px;
}
.goods-edit-page .avatar-mini {
  width: 72px;
  height: 72px;
}
.goods-edit-page .w200 {
  width: 200px !important;
}
.goods-edit-page .w400 {
  width: 400px !important;
}
.goods-edit-page .edit-dom {
  width: 800px;
  margin: 20px auto;
  text-align: left;
  box-shadow: 1px 1px 3px #dfdfdf;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
  margin-top: 64px;
}
</style>


// WEBPACK FOOTER //
// src/pages/goods/Edit.vue